import $ from "jquery";
import axios from "axios";
import { TweenMax } from "gsap";
import { usarTamanhoSalvo } from './TamanhoSalvo';
import Intellibrand from './Intellibrand';

/**
 * Esta var serve para abrir o modal apenas depois dele tiver sido configurado
 * pelo html, assim não abre com as opções default
 * NOTA: As opções default servem apenas para consulta e testes
 */
var modalcompra_init = false;

var modalConfig = {};

var API = {
  searchEan(ean) {
    $('.modalcompra-lista').hide();
    $('.modalcompra-lista-message').html('Carregando').show();
    
    if(!ean) {
      $('.modalcompra-lista-message').html('');
      return;
    }

    Intellibrand.API.searchEan(ean).then(response => {
      console.log('la response ', response);
      if(response && response.data && response.data.offers) {
        makeResultadoAPI(response.data.offers);
      } else {
        $('.modalcompra-lista-message').html('Nenhuma oferta encontrada');
      }
    })
  },
};

/**
 * Opções default
 */
var defaultModalConfig = {
  mobileMaxWidth: 879,
}; /*{
  title: 'PomPom <span>Teste</span>',
  options: [
    {
      label: 'P - Pequeno',
      options: [
        { label: '20 Fraldas', value: '7896012877456' },
        { label: '30 Fraldas', value: 'ean' },
        { label: '48 Fraldas', value: 'ean' },
      ]
    },
    {
      label: 'M - Médio',
      options: [
        { label: '25 Fraldas', value: 'ean' },
        { label: '31 Fraldas', value: 'ean' },
        { label: '49 Fraldas', value: 'ean' },
      ]
    },
    {
      label: 'G - Grande',
      options: [
        { label: '26 Fraldas', value: 'ean' },
        { label: '32 Fraldas', value: 'ean' },
        { label: '50 Fraldas', value: 'ean' },
      ]
    }
  ]
};*/

modalConfig = $.extend({}, defaultModalConfig);

/**
 * Função global para que possa configurar as opções desse modal no html
 * 
 * @global
 * @param {object} modalConfig 
 */
window.initModalCompra = function(_modalConfig) {
  modalcompra_init = true;
  modalConfig = $.extend({}, defaultModalConfig, _modalConfig);
  console.log('initModalCompra:: ', modalConfig);
  $(document).ready(() => { setTimeout(() => {
    if(modalConfig.className) $('.modalcompra').addClass(modalConfig.className);
  }, 3000); });
};

/**
 * Cria o html de opções de tam. de fralda
 */
function htmlOptionsFralda() {
  let options = '';
  for(let i=0; i<modalConfig.options.length; i++) {
    options += '<option value="' + i + '">' + modalConfig.options[i].label + '</option>';
  }
  return options;
}

/**
 * Cria o html de opções de tam. de pacote (depende do tam. de fralda)
 */
function htmlOptionsPacote() {
  let findex = $('.modalcompra-select-fralda').val();
  let foption = modalConfig.options[findex];
  // console.log('htmlOptionsPacote ', findex, foption);
  let options = '';
  for(let i=0; i<foption.options.length; i++) {
    options += '<option value="'
      + foption.options[i].value + '|:|' + (foption.options[i].image || '') + '">'
      + foption.options[i].label
      + '</option>';
  }
  return options;
}

/**
 * Essa função atualiza as opções de tamanho de pacote
 * quando tamanho de fralda for alterado
 */
function refreshPacotes() {
  $('.modalcompra-select-pacote').html(htmlOptionsPacote());
  $('.modalcompra-select').selectric('refresh');
}

/**
 * Essa função atualiza a imagem do modal de acordo com o tamanho selecionado
 */
function refreshImage() {
  let image = $('.modalcompra-select-pacote').val().split('|:|')[1];
  if(image) {
    $('.modalcompra-logo').css({ 'background-image': "url('" + image + "')" });
  }
}

/**
 * Retorna o EAN atual
 */
function getCurrentEan() {
  return $('.modalcompra-select-pacote').val().split('|:|')[0];
}

/**
 * Seta o EAN atual (Seleciona as opções corretas no modal)
 * 
 * @param {*} ean 
 */
function setCurrentEan(ean) {
  // Encontrar a opção correta
  let s1Index = -1;
  let s2Index = -1;
  let s2Value = '';
  for(let i=0; i<modalConfig.options.length; i++) {
    let foption = modalConfig.options[i];

    for(let j=0; j<foption.options.length; j++) {
      if(foption.options[j].value == ean) {
        s1Index = i;
        s2Index = j;
        s2Value = ean + '|:|' + foption.options[j].image;
        break;
      }
    }

    if(s2Index >= 0) break;
  }
  if(s1Index >= 0 && s2Index >= 0) {
    let elModal = $('.modalcompra');
    let elSelectFralda = elModal.find('.modalcompra-select-fralda');
    let elSelectPacote = elModal.find('.modalcompra-select-pacote');

    elSelectFralda.val(s1Index+'');
    elSelectFralda.selectric('refresh');
    refreshPacotes();
    elSelectPacote.val(s2Value);
    elSelectPacote.selectric('refresh');
    refreshImage();
  }
}

/**
 * Ajusta o modal pra funcionar no mobile
 */
function setupMobileLayout() {
  let elModal = $('.modalcompra');
  let elLeft = elModal.find('.modalcompra-left');
  let elRight = elModal.find('.modalcompra-right');
  let elMobileActions = elModal.find('.modalcompra-mobile-actions');
  let elMobileButton = elMobileActions.find('button');
  let elSelectFralda = elModal.find('.modalcompra-select-fralda');

  elMobileButton.off('click');

  if($(window).width() > modalConfig.mobileMaxWidth) {
    // DESKTOP
    elModal.data('mobile', 'no');
    elLeft.show();
    elRight.show();
    elMobileActions.hide();
  } else {
    // MOBILE
    elModal.data('mobile', 'yes');
    elLeft.show();
    elRight.hide();
    elMobileActions.show();

    elMobileButton.on('click', () => {
      // elSelectFralda.trigger('change');
      elLeft.hide();
      elRight.fadeIn();
      API.searchEan(getCurrentEan());
    });
  }
}

/**
 * Abre o modal
 * 
 * @private
 */
function open(ean) {
  if(!modalcompra_init) return;
  let elModal = $('.modalcompra');
  let elContent = elModal.find('.modalcompra-content');
  let elTitle = elModal.find('.modalcompra-title');
  
  setupMobileLayout();
  
  // Refresh data
  elTitle.html(modalConfig.title);
  if(typeof modalConfig.label1 === 'string') {
    $('.modalcompra-label1').html(modalConfig.label1);
  }
  if(typeof modalConfig.label2 === 'string') {
    $('.modalcompra-label2').html(modalConfig.label2);
  }
  $('.modalcompra-select-fralda').html(htmlOptionsFralda());
  refreshPacotes();
  refreshImage();
  if(ean) setCurrentEan(ean);
  API.searchEan(getCurrentEan());

  // Initial state
  TweenMax.set(elModal, {
    display: 'block',
    opacity: 0,
  });

  TweenMax.set(elContent, {
    opacity: 0,
    marginTop: '-100px',
  });

  // Animation
  TweenMax.to(elModal, .3, { opacity: 1 });
  TweenMax.to(elContent, 1, { opacity: 1, marginTop: 0 });

  // Re-bindings
  let elCloses = elModal.find('[data-modalcompra-close]');
  elCloses.off('click');
  elCloses.on('click', () => {
    if(elModal.data('mobile') == 'no') {
      // DESKTOP
      close(elModal);
    } else {
      // MOBILE
      closeMobile(elModal);
    }
  });
  // let elSelects = elModal.find('.modalcompra-select');
  // elSelects.off('change.selall');
  // elSelects.on('change.selall', () => {
  //   refreshImage();
  // });
  let elSelectFralda = elModal.find('.modalcompra-select-fralda');
  elSelectFralda.off('change.fralda');
  elSelectFralda.on('change.fralda', () => {
    refreshPacotes();
    refreshImage();
    let cean = getCurrentEan();
    API.searchEan(cean);
    let optionIndex = elSelectFralda.val();
    let tamanho = modalConfig.options[optionIndex] && modalConfig.options[optionIndex].value || '';
    usarTamanhoSalvo(tamanho);
  });
  let elSelectPacote = elModal.find('.modalcompra-select-pacote');
  elSelectPacote.off('change.pacote');
  elSelectPacote.on('change.pacote', () => {
    refreshImage();
    let cean = getCurrentEan();
    API.searchEan(cean);
  });
  
}

/**
 * Fecha o modal
 * 
 * @private
 * @param {jQuery} elModal 
 */
function close(elModal) {
  let elContent = elModal.find('.modalcompra-content');

  TweenMax.to(elContent, .3, { opacity: 0, marginTop: '-100px' });
  TweenMax.to(elModal, .4, { opacity: 0, display: 'none' });
}

/**
 * Fecha o modal ou volta para o formulário
 * 
 * @private
 * @param {jQuery} elModal 
 */
function closeMobile(elModal) {
  let elLeft = elModal.find('.modalcompra-left');
  let elRight = elModal.find('.modalcompra-right');

  if(elLeft.css('display') == 'none') {
    elRight.hide();
    elLeft.fadeIn();
  } else {
    close(elModal);
  }
}

/**
 * Após receber os dados da API, esta função é chamada para montar o HTML
 * de acordo com as ofertas (response.data.data.offers)
 * 
 * @param {Array} ofertas 
 */
function makeResultadoAPI(ofertas) {
  let newOfertas = [];

  for(let o=0; o<ofertas.length; o++) {
    let preco = precoFormatado(ofertas[o].price);
    if(preco && ofertas[o].url) {
      ofertas[o].price = preco;
      newOfertas.push(ofertas[o]);
    }
    if(newOfertas.length >= 5) {
      break;
    }
  }

  if(!newOfertas.length) {
    $('.modalcompra-lista-message').html('Nenhuma oferta encontrada').show();
    $('.modalcompra-lista').hide();
    return;
  }

  let numOfertas = newOfertas.length;
  
  let html = `
    <div class="modalcompra-lista-row-header-mobile">
      <span class="num_ofertas">${numOfertas}</span> ofertas
    </div>
    <div class="modalcompra-lista-row-header">
      <div class="modalcompra-lista-col-loja">Loja</div>
      <div class="modalcompra-lista-col-preco">Preço</div>
      <div class="modalcompra-lista-col-action"><span class="num_ofertas">${numOfertas}</span> ofertas</div>
    </div>`;
  
  for(let i=0; i<newOfertas.length; i++) {
    html += '\
      <div class="modalcompra-lista-row">\
        <div class="modalcompra-lista-col-loja">\
          <img src="' + newOfertas[i].retailerLogo + '" alt="">\
        </div>\
        <div class="modalcompra-lista-col-preco">\
          ' + newOfertas[i].price + '\
        </div>\
        <div class="modalcompra-lista-col-action">\
          ' + (newOfertas[i].url ? '\
            <a href="' + newOfertas[i].url +
            '" class="ir_para_a_loja" target="_blank">Comprar</a>' :
            '&nbsp;' ) + '\
        </div>\
      </div>';
  }
  
  $('.modalcompra-lista-message').hide();
  $('.modalcompra-lista').html(html).show();
}

function precoFormatado(n) {
  if(!(n>0)) return '';
  let preco = '';
  preco = n.toFixed(2).split('.');
  preco[0] = "R$ " + preco[0].split(/(?=(?:...)*$)/).join('.');
  return preco.join(',');
}













var template = `<div class="modalcompra">
<div class="modalcompra-overlay" data-modalcompra-close></div>
<div class="modalcompra-content">
  <button type="button" class="modalcompra-btn-close" data-modalcompra-close></button>
  <div class="modalcompra-left">
    <div class="modalcompra-logo"></div>
    <div class="modalcompra-form">
      <h3 class="modalcompra-title">Proteção <span>de Mãe</span></h3>
      
      <div class="modalcompra-field">
        <label class="modalcompra-label1">Tamanho da Fralda</label>
        <select class="modalcompra-select modalcompra-select-fralda"></select>
      </div>

      <div class="modalcompra-field">
        <label class="modalcompra-label2">Tamanho do Pacote</label>
        <select class="modalcompra-select modalcompra-select-pacote"></select>
      </div>

      <div class="modalcompra-mobile-actions">
        <button class="highlight-button modalcompra-btn-search">Encontrar Ofertas</button>
      </div>
    </div>
  </div>
  <div class="modalcompra-right">
    <div class="modalcompra-lista-message">
      Nenhuma oferta encontrada
    </div>
		<div class="modalcompra-lista"></div>
		<div class="modalcompra-termos">
			Você será redirecionado para o site de um terceiro, e é necessário que leia os seus 
			Termos e Condições. A Falcon não se responsabiliza pelo conteúdo e pelas políticas 
			de sites de terceiros, dessa forma, é importante notar que, ao comprar um produto 
			anunciado por terceiro, você, Usuário, estará sujeito às regras e condições de oferta 
			disponibilizadas pelo próprio terceiro, para o qual está ciente e concorda 
			expressamente que a Falcon não é responsável pelo conteúdo, prazo de entrega, 
			disponibilidade, estoque e condições da oferta do terceiro. O valor da oferta acima 
			não contempla o frete. Por favor, verifique se o parceiro entrega na sua região, é 
			possível encontrar esta informação no site do varejista.
		</div>
  </div>
  <div class="clearfix"></div>
</div>
</div>`;





















/**
 * Bootstrap
 */
export default function() {
  $('.modalcompra-select').selectric();

  $('[data-modalcompra-open]').click(function() {
    open( $(this).attr('data-modalcompra-open') );
  });

  $('.modalcompra').remove();
  $('body').append(template);
};
